module.exports = __webpack_public_path__ + "static/media/promo_help_pic_agency@3x.d45304043ad69a35ca21cf5ed5144636.png";